const envUrl =
  typeof import.meta !== 'undefined'
    ? (import.meta.env?.VITE_API_URL as string | undefined)
    : undefined;
const API_V1 = (envUrl ?? '/api/v1').replace(/\/$/, '');

export function apiV1Path(path: string): string {
  return `${API_V1}${path.startsWith('/') ? path : `/${path}`}`;
}

export function xatSmilieImageUrl(params: Record<string, string>): string {
  return `${apiV1Path('/xat/smilie/image')}?${new URLSearchParams(params)}`;
}

export function xatAceFrameImageUrl(frameId: string): string {
  return apiV1Path(`/xat/ace-frame/${encodeURIComponent(frameId)}/image`);
}

export const XAT_API = {
  powerinfo: (power: string) => apiV1Path(`/xat/powerinfo/${encodeURIComponent(power)}`),
  powerlogs: (power: string) => apiV1Path(`/xat/powerlogs/${encodeURIComponent(power)}`),
  stickerlist: (power: string) => apiV1Path(`/xat/stickerlist/${encodeURIComponent(power)}`),
  fairtradePrices: () => apiV1Path('/xat/fairtrade-prices'),
  prices: () => apiV1Path('/xat/prices'),
  /** Proxy interno — nunca chamar api.xatblog.net/onlinecheck no browser. */
  onlinecheck: (id: string) => apiV1Path(`/xat/onlinecheck/${encodeURIComponent(id)}`),
  onlinecheckBatch: (ids: string[]) =>
    `${apiV1Path('/xat/onlinecheck')}?ids=${encodeURIComponent(ids.join(','))}`,
  collectionlist: () => apiV1Path('/xat/collectionlist'),
  allpowersRequired: () => apiV1Path('/xat/allpowers-required'),
  latestPower: () => apiV1Path('/xat/latest-power'),
  countdown: () => apiV1Path('/xat/countdown'),
  xatProfile: (params: { id?: string; regname?: string }) => {
    const qs = new URLSearchParams();
    if (params.id) qs.set('id', params.id);
    if (params.regname) qs.set('regname', params.regname);
    return `${apiV1Path('/xat/xat-profile')}?${qs}`;
  },
  smilieValidate: (names: string) =>
    `${apiV1Path('/xat/smilie/validate')}?names=${encodeURIComponent(names)}`,
  oracle: (path: string) => apiV1Path(`/xat/oracle/${path}`),
  aceFrameUpload: () => apiV1Path('/xat/ace-frame/upload'),
};
